import * as React from 'react';

import { ProgressBar } from '@opendoor/bricks/complex';
import { Box, Flex, Image, Link } from '@opendoor/bricks/core';
import imgixUrl from '@opendoor/bricks/helpers/imgixUrl';
import { useTheme } from '@opendoor/bricks/system/theme';

import { isOpendoorAppEvoWebView } from 'src/helpers/webview';

interface ILayoutProps {
  children: React.ReactNode;
  currentSlug?: string;
  progressPercentage: number;
  carrotText?: string;
  hideFooter?: boolean;
  hideProgressBar?: boolean;
  renderNavigationControl?: () => JSX.Element | undefined;
}

const Layout: React.FC<ILayoutProps> = ({
  carrotText,
  hideProgressBar,
  progressPercentage,
  children,
  renderNavigationControl,
}) => {
  const { colors } = useTheme();
  return (
    <>
      {!isOpendoorAppEvoWebView && (
        <Box maxWidth={['375px', null, '100%']}>
          <Link href="/" analyticsName="reception-fe-exclusives-logo" aria-label={null}>
            <Box pt={8} pl={6}>
              <Image
                src={imgixUrl('2023-06-1687274277690-47765.png')}
                alt="Opendoor Exclusives Logo"
                height={['20', null, '24']}
                className="opendoor-exclusives-logo"
              />
            </Box>
          </Link>
        </Box>
      )}
      <Flex justifyContent={'center'}>
        <Flex mx={6} pb="80px" pt="32px" justifyContent="center" maxW={['375px', null, '560px']}>
          {children}
        </Flex>
        <Box position="fixed" bottom="0" width="100%" margin="0" padding="0" background="#fff">
          <Box data-testid="progress-bar">
            {!hideProgressBar && (
              <ProgressBar
                progress={progressPercentage}
                carrotText={carrotText}
                carrotPositionDesktop="below"
                dockPositionMobile="above"
                gradientProgress={false}
                colorStart={colors.brand50 as string}
              />
            )}
          </Box>
          <Flex width="100%" px={6} py="14px">
            {renderNavigationControl && renderNavigationControl()}
          </Flex>
        </Box>
      </Flex>
    </>
  );
};
export default Layout;
